import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { WpTokenService } from '../core/auth/wp-token.service';

import { retry, catchError, map } from 'rxjs/operators';
import { SocialShareModel } from '../models/buy-insurance.model';
import { Observable, throwError } from 'rxjs';

import { BaseComponents } from '../base.component';

import bkiConfig from 'src/app/core/data/bkiConfiguration.json'
import { saveBuyonlineAccessToken, withBuyonlineAccessToken } from 'src/app/core/buy-insurance-access.util';

@Injectable()
export class BuyInsuranceService extends BaseComponents{

  constructor(
    protected injectorObj:Injector,
    public httpClient: HttpClient,
    public wpTokenService: WpTokenService,
    //private logger: NGXLogger
  ) { 
    super(injectorObj);
  }

  share(param: any, ref: any = ''): Observable<any> {
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/share`, param).pipe(
      //retry(1),
      catchError(this.handdleException),
      map(payload => {
        let url = window.location.origin + "/buy-insurance?shareId=" + param.shareId
        if (payload["accessToken"]) {
          saveBuyonlineAccessToken(param.shareId, payload["accessToken"]);
          url += "&accessToken=" + encodeURIComponent(payload["accessToken"]);
        }
        this.logger.info("payload: ", url)
        if (payload["data"] !== "OK") {
          url = null
        }
        return url
      }),
    )
  }

  getShare(param: any, ref: any = ''): Observable<SocialShareModel> {
    const body = withBuyonlineAccessToken(param.shareId, param);
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/get-share`, body).pipe(
      ///retry(1),
      catchError(this.handdleException),
      map(payload => {
        //this.logger.info("payload: ", payload)
        let result: SocialShareModel = payload["data"]
        return result
      }),
    )
  }

  order(param: any, ref: any = ''): Observable<any> {

    if (param.data.model.bki.sub_type && param.data.model.bki.plan_name) {
      let sub_type = param.data.model.bki.sub_type
      let plan_name = param.data.model.bki.plan_name
      param.data.model.bki.bean["prod_type"] = bkiConfig[sub_type]["prod_type"]
      param.data.model.bki.bean["patn_plan"] = bkiConfig[sub_type]["patn_plan"] + plan_name.replace(/[^0-9\.]+/g, "")
    }
    this.logger.debug(["payment:","order() param:",JSON.stringify(param)]);
    // The token reference1 issued for this buyId; the backend refuses to write the order without it.
    const body = withBuyonlineAccessToken(param.buyId, param);
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/order?ref=${ref}`, body).pipe(
      map((payload: any) => {
        if (payload?.accessToken && param.buyId) {
          saveBuyonlineAccessToken(param.buyId, payload.accessToken);
        }
        return payload;
      })
    )
  }

  getOrder(param: any, ref: any = ''): Observable<any> {
    const body = withBuyonlineAccessToken(param.buyId, param);
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/get-order?ref=${ref}`, body).pipe(
      ///retry(1),
      catchError(this.handdleException),
      map(payload => {
        //this.logger.info("payload: ", payload)
        let result: any = payload["data"]
        return result
      }),
    )
  }

  checkPayment(param: any, ref: any = ''): Observable<any> {
    const body = withBuyonlineAccessToken(param.buyId, param);
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/check-payment?ref=${ref}`, body).pipe(
      ///retry(1),
      catchError(this.handdleException),
      map(payload => {
        //this.logger.info("payload: ", payload)
        let result: any = payload
        return result
      }),
    )
  }

  retryCheckPayment(param: any, ref: any = ''): Observable<any> {
    const body = withBuyonlineAccessToken(param.buyId, param);
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/retry-check-payment?ref=${ref}`, body).pipe(
      ///retry(1),
      catchError(this.handdleException),
      map(payload => {
        //this.logger.info("payload: ", payload)
        let result: any = payload
        return result
      }),
    )
  }

  chargeSession(param: any, ref: any = ''): Observable<any> {
    const body = withBuyonlineAccessToken(param.buyId, param);
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/chargeSession?ref=${ref}`, body).pipe(
      catchError(this.handdleException),
      map(payload => payload),
    );
  }

  paymentFailNotify(param: any, ref: any = ''): Observable<any> {
    const body = withBuyonlineAccessToken(param.buyId, param);
    return this.httpClient.post(`${environment.endpointBackend}/api/v1/buyInsurance/payment-fail-notify?ref=${ref}`, body).pipe(
      catchError(this.handdleException),
      map(payload => payload),
    )
  }

  handdleException(error: HttpErrorResponse): Observable<never> {
    //this.logger.info(error)
    return throwError(error)
  }










}
